<template>
    <div class="title_comm">
        <button class="back_arrow" type="button" @click="isPaymentOptionsPageVisible ? backToDepositAmount() : $router.push('/')">
            <img src="@/assets/images/back_arr.svg" alt="back_arrow" />
        </button>
        <div class="header-page-title">
            <h3>{{$t('deposit','Deposit')}}</h3>
        </div>  
    </div>
    <section class="depositMain-page">
        <template v-if="!isPaymentOptionsPageVisible">
            <div class="bet_body box_shadow payment_opiton enter_amount">
                <div class="flex_between">
                <label class="payment_op">{{$t('deposit-amount', 'Deposit Amount')}} <sup class="requ">*</sup></label>
                 <span class="min_max-amount_title minMax-value-btn">
                    <span>{{$t('min','Min')}} {{ minAmount }}</span>
                    <span class="text-x"> |  </span>
                    <span>{{$t('max','Max')}}  {{ maxAmount }}</span>
                </span>
                </div>
                <div class="amount-field inr" :class="!amount || amount < (minAmount) ? 'amount-danger' : 'amount-success'">
                    <input type="tel" :placeholder="$t('enter-amt', 'Enter Deposit Amount')" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.deposit_range?.max || 99999999)" v-model="amount" class="form-control">
                    <button class="inr_number" type="button"></button>
                </div>
                <ul class="btn_group" v-if="walletData">
                    <template  v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes].splice(0, 4) : walletConfig?.stake_button)" :key="index">
                        <li @click="setAmount(stake)">
                            <button class="enter_amount" type="button">+{{ stake }}</button>
                        </li>
                    </template>
                </ul>
                <div class="header-but info-footer edit-stake-btn">
                    <button type="button" class="thm-but thm-bor-but cancel-btn" 
                    data-bs-toggle="modal" data-bs-target="#editstackModal">{{$t('edit-stake','Edit Stake')}}</button>
                    <button class="thm-but " :disabled="amount < walletConfig?.deposit_range?.min" @click="showThePaymentOptionsPage" type="button">
                        {{$t('next','Next')}}
                    </button>
                </div>
            </div>
        </template>
        <!-- when pressed Next -->
        <template v-if="isPaymentOptionsPageVisible">
            <div class="bet_body box_shadow payment_opiton">
                <div class="flex_between">
                    <div class="payment_op">
                        <!-- {{$t('payment-options', 'Payment Options')}} <span class="counnt-dynamic">({{ paymentMethods?.length || 0 }})</span> -->
                    </div>
                    <div class="slide_btn">
                        <button class="nav-left a_btn arr_w me-1"><img loading="lazy" src="@/assets/images/left_a.svg" alt="arrow-left" @click="scrollLeft"/></button>
                        <button class="nav-right a_btn arr_w"><img loading="lazy" src="@/assets/images/right_a.svg" alt="arrow-right" @click="scrollRight"/></button>
                    </div>
                </div>

                <div class="upi_types">
                    <ul class="nav nav-pills" id="pills-tab" role="tablist" ref="scrollableList">
                        <li class="nav-item" role="presentation" v-for="(method, index) in paymentMethods" :key="index">
                            <div class="get-bonus-sec" v-if="paymentBonus?.[method?.[0]?.method_id]">Get {{ paymentBonus?.[method?.[0]?.method_id] }}% Bonus</div>
                            <label :for="'flexRadioDefault1'+getSafeTabId(method, index)" class="nav-link" :class="{'active': activeTab === index}" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">
                                <div class="upi_btn" @click="choosePaymentMethod(method, index)">
                                    <div class="upi_btn-pic">
                                    <img loading="lazy" :src="methodIcons[index]" />
                                    </div>
                                    <span>{{ index }}</span>
                                </div>
                                <input class="form-check-input tab_check" type="radio" value="" name="flexRadioDefault" :id="'flexRadioDefault1'+getSafeTabId(method, index)"  :checked="activeTab === index"  />
                                <span class="form-check-tab_check" v-if="activeTab === index">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7069 5.29303C16.8944 5.48056 16.9997 5.73487 16.9997 6.00003C16.9997 6.26519 16.8944 6.5195 16.7069 6.70703L8.70692 14.707C8.51939 14.8945 8.26508 14.9998 7.99992 14.9998C7.73475 14.9998 7.48045 14.8945 7.29292 14.707L3.29292 10.707C3.11076 10.5184 3.00997 10.2658 3.01224 10.0036C3.01452 9.74143 3.11969 9.49062 3.3051 9.30521C3.49051 9.1198 3.74132 9.01464 4.00352 9.01236C4.26571 9.01008 4.51832 9.11087 4.70692 9.29303L7.99992 12.586L15.2929 5.29303C15.4804 5.10556 15.7348 5.00024 15.9999 5.00024C16.2651 5.00024 16.5194 5.10556 16.7069 5.29303Z" fill="white" stroke="white"/>
                                    </svg>
                                </span>
                            </label>
                        </li>
                    </ul>
                    <span v-if="selectPaymentAccount?.method == 'bank' && !isPaymentGateway">You can add through a bank transfer</span>
                </div>
            </div>
            <div class="guidePoint-details wallet-lang-tabs" id="collapseExample" v-if="hasRules">
                <ul class="nav nav-pills mb-3" id="rules-tab" role="tablist">
                    <template v-for="(value, lang) in walletConfig?.rules?.deposit" :key="lang">
                        <li class="nav-item" role="presentation" v-if="value && value?.length > 0">
                            <button class="nav-link" :class="{ active: lang === activeLanguage }" :id="`rules-${lang}-tab`" data-bs-toggle="pill" :data-bs-target="`#pills-${lang}`"
                                type="button" role="tab" :aria-controls="`rules-${lang}`" :aria-selected="lang === activeLanguage" @click="activeLanguage = lang">
                                {{ lang }}
                            </button>
                        </li>
                    </template>
                </ul>
                <div class="tab-content" id="rules-tabContent">
                    <div class="tab-pane fade show active" v-for="(message, lang) in walletConfig?.rules?.deposit" 
                        :key="lang" v-show="lang === activeLanguage"   :id="`rules-${lang}`" role="tabpanel" :aria-labelledby="`rules-${lang}-tab`">
                        <div v-for="(point, index) in message" :key="index">
                            <div class="guide-list" v-html="point.description"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cond_div" v-else>
                <p>1. {{$t('deposit-money-only-in-the-below-available','Deposit money only in the below available accounts to get the fastest credits and avoid possible delays.')}}</p>
                
                <div class="details_d" :class="[{ 'details_more': showAll }]">
                    <p>
                        2. {{$t('deposits-made-45-minutes-after-the-account','Deposits made 45 minutes after the account removal from the site are valid &amp; will be added to their wallets.')}}
                    </p>
                    <p>
                        3. {{$t('site-is-not-responsible-for-money','Site is not responsible for money deposited to Old, Inactive or Closed accounts.')}}
                    </p>
                    <p>
                        4. {{$t('deposite-note-2','After deposit, add your UTR and amount to receive balance.')}}
                    </p>
                    <p>
                        5. {{$t('deposite-note-4','NEFT receiving time varies from 40 minutes to 2 hours.')}}
                    </p>
                </div>
                <button class="v_ml" type="button" @click="toggleSeeAll">
                    {{ showAll ? $t('see-less','See Less') : $t('see-more','See More')+'...' }}
                </button>
            </div>
            <div class="" v-if="selectedPaymentDetails?.length && selectedPaymentDetails?.[0]?.method != 'social'">
                <div class="payment_gatway_section" v-if="isPaymentGateway">
                    <h4>Pay using our payemnt gateway</h4>
                    <a href="Javascript:void(0);" @click="goToPaymentGateway()" class="thm-but">{{ $t('pay-now', 'Pay Now') }}</a>
                </div>
                <div class="tab-content" id="pills-tabContent" v-if="paymentMethods && !isPaymentGateway">
                    <div class="tab-pane fade show"  v-for="(method, index) in paymentMethods" :key="index" :id="getSafeTabId(method, index)" :class="{ 'active': activeTab === index }" role="tabpanel" :aria-labelledby="getSafeTabId(method, index) + '-tab'">
                        <div class="inner_body">
                            <div class="bet_body box_shadow payment_opiton payment_opt" :class="{ active: selectPaymentAccount?.master_account_id === bank?.master_account_id }" v-for="(bank, index) in selectedPaymentDetails" :key="index" @click="selectPaymentMethodAccount(bank)">
                                <div class="payment_op p_details">{{$t('payment-details', 'Payment Details')}}</div>
                                        <div class="c_text" v-if="bank?.bank_name">
                                            <span class="t_acc">{{ $t('bank-name', 'Bank Name') }}</span>
                                            <div class="flex_between">
                                                <span class="payment_op">{{ bank?.bank_name }}</span>
                                                <span>
                                                    <button class="copy_btn" @click="copyPaymentData($event,$t('bank-name', 'Bank Name'), bank?.bank_name,index)" type="button">
                                                        <img src="@/assets/images/c_text.svg" alt="copy" />
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                         <div class="c_text" v-if="bank?.account_number">
                                             <span class="t_acc">{{ $t('account-number', 'Account Number') }}</span>
                                             <div class="flex_between">
                                                 <span class="payment_op">{{ bank?.account_number }}</span>
                                                 <span>
                                                     <button class="copy_btn bg_Success" @click="copyPaymentData($event,$t('account-number', 'Account Number'),bank?.account_number,index)" type="button">
                                                         <img  src="@/assets/images/c_text.svg" alt="copy" />
                                                     </button>
                                                 </span>
                                             </div>
                                         </div>

                                         <div class="c_text" v-if="bank?.phone_number">
                                             <span class="t_acc">{{ $t('phone-number', 'Phone Number') }}</span>
                                             <div class="flex_between">
                                                 <span class="payment_op">{{ bank?.phone_number }}</span>
                                                 <span>
                                                     <button class="copy_btn bg_Success" @click="copyPaymentData($event,$t('phone-number', 'Phone Number'),bank?.phone_number,index)" type="button">
                                                         <img  src="@/assets/images/c_text.svg" alt="copy" />
                                                     </button>
                                                 </span>
                                             </div>
                                         </div>

                                         <div class="c_text">
                                             <span class="t_acc">{{ bank?.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID') }}</span>
                                             <div class="flex_between">
                                                 <span class="payment_op">{{ bank?.account_number ? bank?.ifsc_code : (bank?.upi_id || bank?.crypto_wallet_id) }}</span>
                                                 <span>
                                                     <button class="copy_btn" type="button" @click="copyPaymentData($event,bank.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID'), bank.account_number ? bank.ifsc_code : (bank?.upi_id || bank?.crypto_wallet_id),index)">
                                                         <img  src="@/assets/images/c_text.svg" alt="copy" />
                                                     </button>
                                                 </span>
                                             </div>
                                         </div>
                                         <div class="c_text">
                                             <span class="t_acc">{{ $t('account-holder-name', 'Account holder’s name') }}</span>
                                             <div class="flex_between">
                                                 <span class="payment_op">{{ bank?.account_holder_name }}</span>
                                                 <span>
                                                     <button class="copy_btn" @click="copyPaymentData($event,$t('account-holder-name', 'Account holder’s name'), bank?.account_holder_name,index)" type="button">
                                                         <img  src="@/assets/images/c_text.svg" alt="copy" />
                                                     </button>
                                                 </span>
                                             </div>
                                         </div>
                                         <div class="c_text" v-if="bank?.crypto_wallet_id">
                                             <span class="t_acc">Deposit Amount</span>
                                             <div class="flex_between">
                                                 <span class="payment_op">
                                                    {{ (amount/bank?.multiplier_value)?.toFixed(2) }} {{ bank?.method_name}}
                                                    <span>( at x{{ Number(bank?.multiplier_value) }} )</span>
                                                 </span>
                                                 <span>
                                                     <button class="copy_btn" @click="copyPaymentData($event,'Deposit Amount', (amount/bank?.multiplier_value),index)" type="button">
                                                         <img  src="@/assets/images/c_text.svg" alt="copy" />
                                                     </button>
                                                 </span>
                                             </div>
                                         </div>
                                        <div class="upload-qr-code-box">
                                            <div class="qr-code" v-if="bank?.qr_code">
                                                <div class="qr-img">
                                                    <img :src="bank?.qr_code" alt="QR-Code">
                                                </div>
                                            </div>
                                            <div class="qr-btn-group" v-if="bank?.qr_code">
                                                <button class="qr-btn" data-bs-toggle="modal" data-bs-target="#qrPreviewModal"  @click="currentImgLink = (bank?.qr_code)">
                                                    <img src="@/assets/images/qr-full-screen.svg" alt="full_screen" />
                                                </button>
                                                <button class="qr-btn" data-bs-toggle="modal" data-bs-target="#qrShareModal" @click="currentImgLink = (bank.qr_code)">
                                                    <img src="@/assets/images/qr-share.svg" alt="qr-share" />
                                                </button>
                                                <a class="qr-btn" @click="downloadQrImg(bank.qr_code, bank?.account_holder_name)"  target="_blank">
                                                    <img src="@/assets/images/qr-downloads.svg" alt="at-download" />
                                                </a>
                                            </div>   
                                        </div>                                
                                    </div>
                                    <div class="bet_body box_shadow payment_opiton enter_amount">
                                        <label class="payment_op">{{ $t('upload-your-payment-slip-below', 'Upload your payment slip below') }} <sup class="requ">*</sup></label>
                                        <div class="uplode_d">
                                            <form id="file-upload-form" class="uploader verificationMobileNumber inr bg-transparent" v-if="!previewImageUtr">
                                                <input id="file-upload" @change="fileUpdateFunc" accept=".png, .jpg, .jpeg, .webp" type="file" name="fileUpload"/>
                                                <label for="file-upload" id="file-drag" class="file_upload-wrap">
                                                    <img src="@/assets/images/uplode-payment.svg" alt="gallery" />
                                                    <div class="file-upload-text">{{$t('upload-or-drop-a-file-right-here', 'Upload or drop a file right here')}}</div>
                                                </label>
                                            </form>
                                            <span class="alert_text" v-if="init.transaction_image_url && !previewImageUtr">{{ $t('please-upload-payment-proof', 'Please Upload Payment Proof') }}</span>
                                            <div v-if="previewImageUtr">
                                                <div class="fileList" >
                                                    <img class="fileList-img" :src="previewImageUtr" alt="file-list"/>
                                                    <button class="add-utr-again" @click="clearPaymentSlip()">&#10006;</button>
                                                    
                                                </div>
                                                <div class="fileList-loader" v-if="utrLoader">{{ timerValue}}</div>
                                                <div class="paymentProofFileUploadStatus" v-if="paymentProofFileUploadStatus">{{ paymentProofFileUploadStatus }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bet_body box_shadow payment_opiton enter_amount">
                                        <label class="payment_op">{{ $t('unique-transaction-reference', 'Unique Transaction Reference') }} <sup class="requ" v-if="selectPaymentAccount?.method != 'wallet'">*</sup></label>
                                        <div class="verificationMobileNumber">
                                            <input type="tel" :maxlength="selectPaymentAccount?.method != 'wallet' ? 15 : 128" class="form-control utr_input_cl" v-model="utrNumber" :disabled="utrLoader" @input="validateUTR(), hasEditedUtr = 1" :placeholder="$t('enter-utr-number', 'Enter UTR number')" />
                                        </div>
                                        <span class="alert_text" v-if="selectPaymentAccount?.method != 'wallet' && init.utr && !utrNumber?.length">{{$t('utr-number-is-required','UTR Number is Required')}}</span>
                                        <span class="alert_text" v-else-if="selectPaymentAccount?.method != 'wallet' && init.utr && utrNumber?.length < 10">{{$t('utr-limit-msg','UTR number must be 10 to 15 digit')}}</span>
                                    </div>
                                    <div class="bet_body box_shadow payment_opiton enter_amount">
                                        <div class="d-flex justify-content-end">
                                            <span class="text-sm_balance">{{$t('current-available-balance', 'Current Available Balance')}}:  {{ availableBalance }} </span>
                                        </div>
                                        <div class="verificationMobileNumber inr">
                                            <input type="number" class="form-control" v-model="amount" readonly />
                                            <button class="edit_amount" type="button" @click="hideThePaymentOptionsPage">{{$t('edit','Edit')}}</button>
                                        </div>
                                    </div>
                                    <div class="read_contant">
                                        <div class="form-check">
                                        <label class="form-check-label" for="flexCheckDefault">
                                            <input class="form-check-input" v-model="termsAgreed" type="checkbox" value="" id="flexCheckDefault"/>
                                            <span class="agree_with">{{$t('i-have-read-and-agree-with','I have read and agree with')}}<a data-bs-toggle="modal" href="#wpolicy-modal-popup" class="withdrawal_policy" @click.stop>
                                                    {{$t('the-terms-of-payment-and-withdrawal-policy','the terms of payment and withdrawal policy.')}}
                                                </a>
                                            </span>
                                        </label>
                                    </div>
                                        <button class="submit_btn" ref="sbtBtn" :disabled="utrLoader" v-if="!isPaymentGateway" @click="walletDepositSubmitBtn()" type="button">
                                            {{$t('submit','SUBMIT')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                <DepositTermsAndConditionModals/>
            </div>
            <DepositSuccessfully :amount="amount"/>
        </template>
         <TutorialVideo type = "2"/>
    </section>

    <StakeModal v-if="walletData" :stakes="walletData"/>
    <QrCodeModal :qrCode="currentImgLink"/>
    <QrCodeShareModal :qrCode="currentImgLink"/>
</template>
<script setup>
import { ref, computed, inject, onMounted, getCurrentInstance } from "vue";
import { useRouter } from 'vue-router';
import { setWalletStakeValue } from "../services/module";
import {getParentPaymentsMethods, onUploadImage,submitDepositAmount,getPaymentGatewayUrl} from "../services/depositPayment";
import TutorialVideo from "../components/TutorialVideo.vue";
import QrCodeShareModal from "@/shared/components/modal/QrCodeShareModal.vue";
import QrCodeModal from "@/shared/components/modal/QrCodeModal.vue";
import DepositTermsAndConditionModals from "../components/DepositTermsAndConditionModals.vue";
import DepositSuccessfully from "../components/DepositSuccessfully.vue";
import StakeModal from "../components/StakeModal.vue";
import { useStore } from 'vuex'

const { $t,$auth, $errorToast, $successToast, $siteSettings } = getCurrentInstance().proxy;

const walletConfig = inject("walletConfig");
const router = useRouter();
const store = useStore();

const currentPaymentId = ref(null);
const currentImgLink = ref(null);
const selectedPaymentDetails = ref([]);
const uploadedImage = ref(null);
const intervalCounter = ref(0);
const timer = ref(null);
const angle = ref(0);
const angle_increment = ref(360 / 9);
const timerValue = ref(6);
const interval = ref(30);
const t = ref(6);
const utrerror = ref(false);
const utrLimitError = ref(false);
const utrNumber = ref(null);
const sbtBtn = ref(null);
const utrMsg = ref({
    langKey: 'enter-utr',
    msg: "Kindly enter UTR Number manually for fast deposit."
});
// const showFileError = ref(false);
// const manualUtrNumber = ref(0);
const manual_utr = ref(null)
const utrLoader = ref(false);
const walletData = ref(null);
const paymentMethods = ref(null);
// const selectedPaymentMethod = ref([]);
const selectPaymentAccount = ref(null);
const termsAgreed = ref(false);
const file = ref(undefined);
const previewImageUtr = ref(null);
const hasEditedUtr = ref(0);
const amount = ref(null);
const showAll = ref(false);
const loading = ref(false);
const isPaymentOptionsPageVisible = ref(false);
const activeTab = ref(null);
const init = ref({
    utr: false,
    transaction_image_url: false,
});
const activeLanguage = ref(null);
const isPaymentGateway = ref(null);
const paymentProofFileUploadStatus = ref('');
const utrCountDown = ref(6);

// ----------------------
// Computed (converted)
// ----------------------
const hasRules = computed(() => {
    if (!walletConfig.value?.rules?.deposit) return false;
    return Object.values(walletConfig.value?.rules?.deposit).some(
        (arr) => arr && arr.length > 0
    );
});

const minAmount = computed(() => {
    return walletConfig.value?.deposit_range?.min ?? 100;
});

const maxAmount = computed(() => {
    return walletConfig.value?.deposit_range?.max ?? 99999999;
});

const methodIcons = computed(() => {
    let iconObj = {};
    walletConfig.value?.payment_method?.forEach((el) => {
        iconObj[el?.method_name] = el.icon;
    });
    walletConfig.value?.bank_list?.forEach((el) => {
        iconObj[el?.bank_name] = el.icon;
    });
    return iconObj;
});

const userTransactionStakes = computed(() => store.getters.userTransactionStakes);
const bonusData = computed(() => store.getters.bonusData);

// computed from $auth
const availableBalance = computed(() => {
      const { balance = 0, expl = 0 } = $auth?.user || {};
      const earnBonus = $auth?.user?.earnBonus || 0;
      return (parseFloat(balance) + parseFloat(expl || 0) - parseFloat(earnBonus)).toFixed(2);
});

const paymentBonus = computed(() => {
    if (!bonusData.value || !Array.isArray(bonusData.value)) return {};

    const paymentBonusData = bonusData.value.filter(
        (bd) => bd.bonusType === "payment bonus"
    );

    if (paymentBonusData.length === 0) return {};

    return paymentBonusData.reduce((map, bonus) => {
        try {
            const methodIds = JSON.parse(bonus.methodIds);
            if (Array.isArray(methodIds)) {
                methodIds.forEach((id) => (map[id] = bonus.percentage));
            }
        } catch (error) {
            console.warn("Failed to parse methodIds:", bonus.methodIds, error);
        }
        return map;
    }, {});
});


onMounted(() => {
    getStakes();
    amount.value = store.getters.depositAmount;

    const messages = walletConfig.value?.rules?.deposit;
    if (messages) {
        activeLanguage.value =
            Object.entries(messages).find(([lang, rules]) => rules.length > 0)?.[0] || null;
    }
});

// Methods (converted directly)

function backToDepositAmount() {
    isPaymentOptionsPageVisible.value = !isPaymentOptionsPageVisible.value;
}

function validateUTR() {
    utrNumber.value = utrNumber.value
        ?.replace(/[^0-9]/g, "")
        .replace(/[+-]/g, "");

    if (!utrNumber.value) {
        utrerror.value = true;
    } else if (utrNumber.value.length < 10 || utrNumber.value.length > 15) {
        utrLimitError.value = true;
    } else {
        utrLimitError.value = false;
        utrerror.value = false;
    }
}

function startTimer() {
    utrLoader.value = true;
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;

    if (timer.value) {
        clearInterval(timer.value);
    }

    timer.value = setInterval(() => {
        intervalCounter.value = intervalCounter.value + 1;
        angle.value = (intervalCounter.value / (t.value * (1000 / interval.value))) * 360;

        timerValue.value = t.value - Math.floor((angle.value / 360) * t.value);

        if (timerValue.value <= 0) {
            resetTimer();
            utrLoader.value = false;
        }
    }, interval.value);
}

function resetTimer() {
    clearInterval(timer.value);
    utrLoader.value = false;
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;
}

function updateCounter() {
    utrLoader.value = true;
    if (utrCountDown.value <= 0) return;

    timer.value = setInterval(() => {
        if (utrCountDown.value > 0) {
            utrCountDown.value--;
        } else {
            utrLoader.value = false;
            clearInterval(timer.value);
        }
    }, 1000);
};

async function goToPaymentGateway() {
    try {
        const response = await getPaymentGatewayUrl(
            amount.value,
            selectedPaymentDetails.value[0]?.master_account_id
        );
        console.log(response);
    } catch (error) {
        $errorToast(error);
    }
}

async function fileUpdateFunc(event) {
    try {
        paymentProofFileUploadStatus.value = 'Fetching payment proof file';
        const file = event.target.files[0];
        if (!file) {
            return $errorToast($t('no-file-selected','No File selected to upload'))
        }
        const allowedTypes = [
            'image/jpeg',
            'image/png',
            'image/jpg',
            'image/webp',
        ];
        if (!allowedTypes.includes(file.type)) {
            return $errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB');
        }
        paymentProofFileUploadStatus.value = 'Payment Proof File found Ready to Process';
        previewImageUtr.value = URL.createObjectURL(file)
        let response = await onUploadImage({
            event,
            depositAmount: amount.value,
            startTimer: startTimer,
            resetTimer: resetTimer,
            sbtBtn: sbtBtn.value,
            updateCounter: updateCounter,
            paymentProofFileUploadStatus
        });
        if(response){
            if(!response?.manual_utr){
                paymentProofFileUploadStatus.value = 'UTR Number Not Found from above payment proof try with different one';
            }else{
                paymentProofFileUploadStatus.value = 'UTR Number Has been successfully extracted !!!';
            }
            manual_utr.value = response?.manual_utr;
            utrMsg.value = response?.utrMsg;
            uploadedImage.value = response?.uploadedImage;
            previewImageUtr.value = response?.previewImage;
            utrNumber.value = response?.tesseract_utr;
            utrLoader.value = false
            if(response.manual_utr){
                hasEditedUtr.value = 0
            }
        }
        else{
            paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
            previewImageUtr.value = null
        }
    } catch (error) {
        previewImageUtr.value = null
        paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
        $errorToast(error)
    }
    finally{
        setTimeout(() => {
            paymentProofFileUploadStatus.value = '';
        }, 2000);
    }
}


async function walletDepositSubmitBtn() {
    toggleInit(true);
    if (selectPaymentAccount.value?.method !== "wallet" && utrNumber.value?.length < 11)
        return;
    try {
        termsAgreed.value = true;
        await submitDepositAmount({
            accountDetails: selectPaymentAccount.value,
            uploadedImage: uploadedImage.value,
            depositAmount: amount.value,
            manual_utr: utrNumber.value,
            has_edited_utr: hasEditedUtr.value,
            removeImage: clearPaymentSlip,
        });

        termsAgreed.value = false;
    } catch (error) {
        $errorToast(error);
        termsAgreed.value = false;
    }
}

function copyImgUrl() {
    const input = document.createElement("textarea");
    input.innerHTML = currentImgLink.value;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    $successToast("Successfully copied.");
}

function copyPaymentData(event, catagory, accountData) {
    const input = document.createElement("textarea");
    input.innerHTML = accountData;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    $successToast(catagory + " Copied");
}

function selectPaymentMethodAccount(paymentAccount) {
    selectPaymentAccount.value = paymentAccount;
    toggleInit(false);
}

function downloadQrImg(imageUrl, name) {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = name;
    link.target = "_blank";
    link.click();
}

function getSafeTabId(method, index) {
    const base = method?.name || `tab-${index}`;
    return ("tab-" + base.toString().replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-_]/g, "").toLowerCase());
}

function setAmount(stake) {
    try {
        const response = setWalletStakeValue(
            stake,
            amount.value,
            walletConfig.value
        );
        if (response) amount.value = response;
    } catch (error) {$errorToast(error);}
}

function getStakes() {
    walletData.value = walletConfig.value?.stake_button;
    // if (!walletData.value) initializeStake();
}

// function initializeStake() {
//     walletData?.value?.stake = {
//         stake1: 100,
//         stake2: 500,
//         stake3: 1000,
//         stake4: 2000,
//     };
// }

function showThePaymentOptionsPage() {
    isPaymentOptionsPageVisible.value = true;
    getParentPaymentMethods();
}

function hideThePaymentOptionsPage() {
    const initialState = proxy.$options.data.call(proxy);
    Object.assign(proxy.$data, { ...initialState, walletData: walletData.value });
}

async function getParentPaymentMethods(reconnectTry = 0) {
    try {
        let response = await getParentPaymentsMethods(reconnectTry,amount.value);
        if (response?.data) {
            paymentMethods.value = response?.data
            const nonSocialStartIndex = response?.nonSocialStartIndex;
            activeTab.value = Object.keys(paymentMethods.value)[nonSocialStartIndex];

            choosePaymentMethod(
                paymentMethods.value[activeTab.value],
                activeTab.value
            );
        }
    } catch (error) {
        if (reconnectTry < 3 && !error) {
            getParentPaymentMethods(reconnectTry + 1);
        } else {
            loading.value = false;
            store.dispatch("setGlobalLoader", false);

            if (error) {
                console.log(error);
                $errorToast(error[0]);
            }
        }
    }
}

function choosePaymentMethod(payment, index) {
    clearPaymentSlip();
    toggleInit(false);
    activeTab.value = index;
    selectedPaymentDetails.value = payment;
    if(payment?.[0]?.method === "social") {
        const socialNumber = payment?.[0]?.social_payment_number;
        const socialLink = payment?.[0]?.social_payment_link;
        if (socialNumber?.length && socialLink?.length) {
            const choice = Math.random() < 0.5 ? "number" : "link"
            if (choice === "number") {
                if (payment?.[0]?.method_name?.toLowerCase().includes("whatsapp")) {
                    window.open(`https://wa.me/?text=${socialNumber}`, "blank");
                } else if (payment?.[0]?.method_name?.toLowerCase().includes("telegram")) {
                    window.open(`https://t.me/${socialNumber}`, "blank");
                }
            } else {
                window.open(socialLink, "blank");
            }
            return;
        }
        if (socialNumber?.length) {
            if (payment?.[0]?.method_name?.toLowerCase().includes("whatsapp")) {
                window.open(`https://wa.me/?text=${socialNumber}`, "blank");
            } else if (payment?.[0]?.method_name?.toLowerCase().includes("telegram")) {
                window.open(`https://t.me/${socialNumber}`, "blank");
            }
            return;
        }
        if (socialLink?.length) {
            window.open(socialLink, "blank");
            return;
        }
        $errorToast($t("no-social-payment-number", "No social payment number available")
        );
        return;
    }
    if (payment?.[0]?.method === "payment_gateway") {
        isPaymentGateway.value = true;
        selectedPaymentDetails.value = payment;
        return;
    }

    activeTab.value = index;
    currentPaymentId.value = payment?.[0]?.method;
    selectedPaymentDetails.value = payment;
    selectPaymentAccount.value = payment?.[0];
    isPaymentGateway.value = false;
}

function toggleInit(bool) {
    init.value = {
        utr: bool,
        transaction_image_url: bool,
    };
}

function clearPaymentSlip() {
    previewImageUtr.value = null;
    utrNumber.value = "";
    file.value = undefined;
    uploadedImage.value = null;
    termsAgreed.value = false;
    // hasEditedUtr.value = 1;
}

function toggleSeeAll() {
    showAll.value = !showAll.value;
}

function scrollLeft() {
    const list = proxy.$refs.scrollableList;
    list.scrollBy({ left: -200, behavior: "smooth" });
}

function scrollRight() {
    const list = proxy.$refs.scrollableList;
    list.scrollBy({ left: 200, behavior: "smooth" });
}
    
</script>
<style scoped>
.bet_body.active {
  border: 2px solid var(--border-withDrawBtn);
  border-radius: 5px; 
}
</style>